<div class="modal">
  <div class="modal__header">
    <div class="grid-row grid-row--aic">
      <div class="grid-col">
        <div class="h3">Cannot Delete Payment Method</div>
      </div>
      <div class="grid-col grid-col--auto">
        <button (click)="onClose()" type="button" class="modal__close">
          <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
    </div>
  </div>
  <div class="modal__cont">
    <p *ngIf="data.isUsedByAutomaticPayments">This payment method is being used by a recurring or scheduled payment and cannot be deleted. If you think this is an error please contact <span class="mt--100 text-link"><a href="{{getEmail()}}">support&#64;aiwyn.ai</a></span> for assistance.</p>
    <p *ngIf="data.isUsedByEngagements">This payment method is set to be used for a prepayment for one or multiple engagements and cannot be deleted. If you think this is an error please contact <span class="mt--100 text-link"><a href="{{getEmail()}}">support&#64;aiwyn.ai</a></span> for assistance.</p>
    <p *ngIf="data.isUsedByPendingPayments">This payment method has a payment that is still being processed and cannot be deleted until the payment is completed. Please try again later.</p>
    <div class="mt--125 grid-row grid-row--jcb">
      <div class="grid-col grid-col--auto">
        <button (click)="onClose()" type="button" class="button">Close</button>
      </div>
    </div>
  </div>
</div>
